// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__headerShareIconCss___2MANV{\n    position: absolute;\n    right: 10px;\n    cursor: pointer;\n}\n\n.styles-module__highlightsWrapperCss___2Mq5A{\n    padding: 0px;\n    margin: 0px;\n    list-style: none\n}\n\n.styles-module__highlightsWrapperCss___2Mq5A li::before {content: \"•\"; color: var(--inverse-lighter)}\n.styles-module__releaseItemCss___2J-pQ{\n    margin-bottom: 4px;\n}\n\n.styles-module__releaseItemCss___2J-pQ:last-child{\n    margin-bottom: 0px;\n}", ""]);
// Exports
exports.locals = {
	"headerShareIconCss": "styles-module__headerShareIconCss___2MANV",
	"highlightsWrapperCss": "styles-module__highlightsWrapperCss___2Mq5A",
	"releaseItemCss": "styles-module__releaseItemCss___2J-pQ"
};
module.exports = exports;
